<template>
	<div>
		<ul uk-tab>
			<li class="uk-active"><a href="#user-data">{{ $t('user.data') }}</a></li>
			<li><a href="#additional-settings">{{ $t('additional.settings') }}</a></li>
		</ul>
		<ul class="uk-switcher uk-margin">
			<li id="user-data">
				<div class="modal_item">
					<label for="individual-person_login">{{ $t('user.login') }}</label>
					<br>
					<input id="individual-person_login" class="textInput attribute-editor" type="text">
					<button class="button_reset fa fa-times"></button>
				</div>
				<div class="modal_item">
					<label for="individual-person_firstName">{{ $t('first.name') }}</label>
					<br>
					<input id="individual-person_firstName" class="textInput attribute-editor" type="text">
					<button class="button_reset fa fa-times"></button>
				</div>
				<div class="modal_item">
					<label for="individual-person_lastName">{{ $t('last.name') }}</label>
					<br>
					<input id="individual-person_lastName" class="textInput attribute-editor" type="text">
					<button class="button_reset fa fa-times"></button>
				</div>
				<div class="modal_item">
					<label for="individual-person_passwordHash">{{ $t('password') }}</label>
					<br>
					<input id="individual-person_passwordHash" class="textInput attribute-editor" type="password">
					<button class="button_reset fa fa-times"></button>
				</div>
				<div class="modal_item">
					<label for="confirmation-password">{{ $t('confirmation.password') }}</label>
					<br>
					<input id="confirmation-password" class="textInput attribute-editor" type="password">
					<button class="button_reset fa fa-times"></button>
				</div>
				<div class="modal_item">
					<div class="checkbox-block">
						<input type="checkbox" id="individual-person_temporaryPassword" class="checkbox attribute-editor">
						<label for="individual-person_temporaryPassword">{{ $t('temporary.password') }}</label>
					</div>
				</div>
				<div class="modal_item">
					<label for="individual-person_country">{{ $t('countries') }}</label>
					<br>
					<select id="individual-person_country" class="select attribute-editor" v-model="country">
						<option v-for="(country, key) in countries" :value="key" :key="key"> {{
								$t(country)
							}}
						</option>
					</select>
				</div>
			</li>
			<li id="additional-settings">
				<div class="modal_item">
					<label for="individual-person_description">{{ $t('description') }}</label>
					<br>
					<textarea id="individual-person_description" class="textarea attribute-editor"></textarea>
					<button class="button_reset single-area-reset fa fa-times"></button>
				</div>
				<div class="modal_item">
					<label for="individual-person_decimalSeparator">{{ $t('decimal.separator') }}</label>
					<br>
					<select id="individual-person_decimalSeparator" class="select attribute-editor">
						<option value=".">.</option>
						<option value=",">,</option>
						<option value="\">\</option>
						<option value=" ">{{ $t('space') }}</option>
						<option value="$">$</option>
					</select>
				</div>
				<div class="modal_item">
					<label for="individual-person_digitGroupingPattern">{{ $t('digit.grouping.pattern') }}</label>
					<br>
					<select id="individual-person_digitGroupingPattern" class="select attribute-editor">
						<option value="0">123456789</option>
						<option value="#,##0">123,456,789</option>
					</select>
				</div>
				<div class="modal_item">
					<label for="individual-person_digitGroupingSeparator">{{ $t('digit.grouping.separator') }}</label>
					<br>
					<select id="individual-person_digitGroupingSeparator" class="select attribute-editor">
						<option value=".">.</option>
						<option value=",">,</option>
						<option value="\">\</option>
						<option value=" ">{{ $t('space') }}</option>
						<option value="$">$</option>
					</select>
				</div>
				<div class="modal_item">
					<label for="individual-person_dateFormat">{{ $t('date.format') }}</label>
					<br>
					<select id="individual-person_dateFormat" class="select attribute-editor">
						<option value="yyyy-MM-dd">yyyy-MM-dd</option>
						<option value="yyyy/MM/dd">yyyy/MM/dd</option>
						<option value="dd-MM-yyyy">dd-MM-yyyy</option>
						<option value="dd/MM/yyyy">dd/MM/yyyy</option>
					</select>
				</div>
				<div id="api-key-box" class="modal_item">
					<label for="individual-person_apiKey">{{ $t('api.key') }}</label>
					<br>
					<input id="individual-person_apiKey" class="textInput attribute-editor" readonly>
					<button id="individual-person_generate-api-key" class="button_refresh fa fa-refresh"></button>
				</div>
				<div class="modal_item" v-if="action !== 'create'">
					<label for="individual-person_apiCompanyId">{{ $t('default.api.organization') }}</label>
					<br>
					<select id="individual-person_apiCompanyId" class="select attribute-editor">
						<option value="">-</option>
						<option v-for="company in companies" :value="company.id">{{ company.name }}</option>
					</select>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
import { getDataFromTextInput } from '@/core/item_assistance/receiveDataFromComponents'
import { emailValidation } from '@/core/shared'

export default {
	name: 'Users',
	data () {
		return {
			country: 'EE'
		}
	},
	props: [
		'id',
		'action',
		'activeAttribute',
		'person'
	],
	computed: {
		countries: function () {
			return this.$store.getters.getCountries
		},
		companies: function () {
			return this.$store.getters.getCompanyList
		}
	},
	async mounted () {
		let vm = this
		let manager = window.manager
		let table = window.table

		await Swal.fire({
			title: vm.$t('user'),
			html: vm.$el,
			confirmButtonText: vm.$t('save'),
			showCancelButton: true,
			cancelButtonText: vm.$t('cancel'),
			buttonsStyling: false,
			allowOutsideClick: false,
			allowEnterKey: true,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				popup: 'button-actions',
				content: 'form ',
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
				cancelButton: 'uk-button uk-button-default uk-button-small'
			},
			onBeforeOpen: function () {

			},
			onRender: function () {
				manager.setProperties({
					action: vm.action,
					individualPersonId: vm.id,
					activeAttribute: vm.activeAttribute,
					postSaveAction: function() {
						table.initTable();
					}
				});
				manager.initPage(vm.person);
			},
			onClose: function () {
				vm.$emit('close-modal')
			},
			preConfirm: function () {
				let individualPersonInformation = manager.getIndividualPersonInformation();

				if (individualPersonInformation['passwordHash'] !== getDataFromTextInput('confirmation-password')) {
					Swal.showValidationMessage(vm.$t("passwords.dont.match"));
					return false;
				} else if (vm.action === 'create' && individualPersonInformation['passwordHash'].length < 8) {
					Swal.showValidationMessage(vm.$t("password.must.be.at.least.8.characters"));
					return false;
				} else if (!emailValidation(individualPersonInformation['login'])) {
					Swal.showValidationMessage(vm.$t("incorrect.email"));
					return false;
				} else if ((vm.action === 'edit') && (!_.isEmpty(individualPersonInformation['passwordHash']) && individualPersonInformation['passwordHash'].length < 8)) {
					Swal.showValidationMessage(vm.$t("password.must.be.at.least.8.characters"));
					return false;
				} else {
					return individualPersonInformation;
				}
			}
		}).then(function (result) {
			if (result.value) {
				let individualPersonInformation = result.value;
				manager.saveIndividualPerson(vm.action, individualPersonInformation);
			}
		})
	}
}
</script>

<style scoped>
.checkbox-block {
	margin: 0;
	display: flex;
	align-items: center;
}

.checkbox-block label {
	margin: 0;
}

.checkbox-block input {
	margin: 0 5px 0 0;
}
</style>
